<template>
          <v-card  style="margin-top: 2rem">
            <v-card-title class="subheading font-weight-bold">{{ item.archive ? item.archive.custom_name : "Brak archiwum" }}</v-card-title>
            <v-divider></v-divider>
            <v-container>
              <v-flex xs12 lg8 offset-xs2>
                <v-img v-if="item.archive && item.archive.thumb_img" :src="'data:image/png;base64,'+ (item.archive && item.archive.thumb_img ? item.archive.thumb_img : '')" aspect-ratio="1" class="cursorPointner"
                       contain max-height="256"
                       max-width="256"></v-img>
              </v-flex>

                <v-text-field style="margin-top: 2rem" :value="getUser(item.created_by)" label="Autor:" prepend-icon="person" readonly></v-text-field>
                <v-text-field style="margin-top: 2rem" :value="item.created_at" label="Czas utworzenia:" prepend-icon="event" readonly></v-text-field>

                <v-text-field  style="margin-top: 2rem" :value="item.schema.name" label="Dokument: "  readonly></v-text-field>
                <v-text-field style="margin-top: 2rem" :value="getStatus(item.status)" label="Status: "  readonly></v-text-field>


              <div v-if="!viewOnly" lg2 sm12>
                <slot name="actions" v-bind:item="item">
                <v-btn  :disabled="item.status == 1" color="green" @click="createForm(item.id)">Przypisz</v-btn>
                  <v-progress-circular v-if="item.status == 1" indeterminate></v-progress-circular>
                </slot>
              </div>
            </v-container>
          </v-card>
</template>

<script>
import Presentation from "@/components/form/Presentation";
import PDFViewer from "@/components/pdf/Viewer"
import Messenger from "@/plugins/Messenger";
export default {
  name: "Waiting",
  components:{
    Presentation,
    PDFViewer
  },
  props: ['item','schemas','viewOnly', ''],
  data:()=>({
    documents : [],
    fields :[],
    file:null,
    schemaAssigned :{},
    loading : true,
    rowsPerPageItems: [4, 8, 12],
    pagination: {
      rowsPerPage: 4
    },
  }),
  created() {

  },
  methods:{
    createForm(documentId){
      this.$router.push(`/document/${documentId}/create-form`)
    },
    assign(documentId){
      let schemaId = this.schemaAssigned[documentId]
      if(!(schemaId >0)){
        Messenger.emitError("Najpierw wybierz schemat")
        return
      }
      let data = {'schema_id' :schemaId, 'document_id' : documentId }
      this.$http.post('document/ocr/assign', data).then(() => {
        this.documents = this.documents.filter(docs => docs.id != documentId)
      }).catch(()=>Messenger.emitError("Błąd"))
    },
    base64toPDF(data) {
      var bufferArray = this.base64ToArrayBuffer(data);
      var blobStore = new Blob([bufferArray], { type: "application/pdf" });
      return blobStore
    },
    base64ToArrayBuffer(data) {
      var bString = window.atob(data);
      var bLength = bString.length;
      var bytes = new Uint8Array(bLength);
      for (var i = 0; i < bLength; i++) {
        var ascii = bString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    getUser(id){
      let user = this.$store.getters.user(id)
      if(!user)
        return ""
      return user.name + " " + user.surname
    },
    getIcon(state){
      switch (parseInt(state)){
      case 1:
        return "waiting"
      case 2:
        return "task_plus"
      default:
        return "error"
      }
    },
    getStatus(state){
      switch (parseInt(state)){
      case 1:
        return "Trwa procesowanie dokumentu"
      case 2:
        return "Oczekuje"
      case 400:
        return "Bład"
      default:
        return "Inny"
      }
    }
  },
}
</script>

<style scoped>
.center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  border: 3px solid green;
}
</style>